import React from 'react';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { UIGameActionBoxPickCard } from '../../common/UIGameActionBox/variants/UIGameActionBoxPickCard/UIGameActionBoxPickCard.tsx';
import { UIGameActionBoxPickPlayer } from '../../common/UIGameActionBox/variants/UIGameActionBoxPickPlayer/UIGameActionBoxPickPlayer.tsx';
import { UIGameActionBoxPickDice } from '../../common/UIGameActionBox/variants/UIGameActionBoxPickDice/UIGameActionBoxPickDice.tsx';
import { UIGameActionBoxBase } from '../../common/UIGameActionBox/UIGameActionBoxBase.tsx';
export const UIGameActionBoxContainer = ({ isPortrait = false })=>{
    const actionBoxData = useGameStore((state)=>state.actionBox.actionBoxData);
    if (!actionBoxData) {
        return null;
    }
    const { type, props } = actionBoxData;
    switch(type){
        case 'pickCard':
            return /*#__PURE__*/ React.createElement(UIGameActionBoxPickCard, {
                key: actionBoxData.id,
                ...props,
                isPortrait: isPortrait
            });
        case 'pickPlayer':
            return /*#__PURE__*/ React.createElement(UIGameActionBoxPickPlayer, {
                key: actionBoxData.id,
                ...props,
                isPortrait: isPortrait
            });
        case 'pickDice':
            return /*#__PURE__*/ React.createElement(UIGameActionBoxPickDice, {
                key: actionBoxData.id,
                ...props,
                isPortrait: isPortrait
            });
        case 'base':
            return /*#__PURE__*/ React.createElement(UIGameActionBoxBase, {
                key: actionBoxData.id,
                ...props,
                isPortrait: isPortrait
            });
    }
};
